import { GraphForm } from "./graph_form";
import { StatsGraph } from "./stats_graph";
import $ from "jquery";

class EasyResearchesForm extends GraphForm {
  public graph: StatsGraph;

  constructor() {
    super();
    // 「定番」の場合はyearly partitionを使用
    const isRegularResearch = this.canvasElement().closest("[data-regular-research]").length > 0;
    const isTrendResearch = this.canvasElement().closest("[data-trend-research]").length > 0;

    let xAxis;
    if (isRegularResearch) {
      // 「定番」の場合はYearlyAxisを使用
      xAxis = StatsGraph.YearlyAxis;
    } else if (isTrendResearch) {
      // 「急上昇」の場合はTrendResearchMonthlyAxisを使用（5年分のデータに対応）
      xAxis = StatsGraph.TrendResearchMonthlyAxis;
    } else {
      xAxis = StatsGraph.AxisPolicy.forPartition(this.partition());
    }

    this.graph = new StatsGraph(this.canvasElement(), {
      xAxis: xAxis,
      yAxis: StatsGraph.FloatAxis,
      legend: StatsGraph.RightColumnLegend,
    });
  }

  protected canvasElement(): JQuery {
    return $("#ksi_graph");
  }

  protected formElement(): JQuery {
    return $("#easy_research_form");
  }

  private partition(): string {
    // 「定番」の場合はyearly、それ以外はmonthly
    const isRegularResearch = this.canvasElement().closest("[data-regular-research]").length > 0;
    if (isRegularResearch) {
      return "yearly";
    }
    return $("#partition").val() as string || "monthly";
  }

  enablePngDownload(): void {
    super.enablePngDownloadButton($(".ksi_graph_box .png_download_button"), this.graph);
  }

  updateCsvUrl(url: string): void {
    const elem = $(".ksi_graph_box .csv_button");
    elem.removeClass("disabled enable_later");
    let a = elem.find("a");

    if (a.length > 0) {
      a.attr("href", url);
    } else {
      const img = elem.html();
      elem.html("<a></a>");
      a = elem.children();
      a.append(img);
      a.attr("href", url);
    }
  }

  onSeriesRemoval(f: (series: any) => void): void {
    this.graph.onSeriesRemoval(f);
  }

  render(): void {
    this.graph.drawAll();
  }

  showNoDataMessage(): void {
    this.graph.drawMessage(`
      この条件では組み合わせのデータが存在しません。
      単語や期間、集計単位などを変更してお試しください。
    `);
  }

  showHttpErrorMessage(res: { status: number }): void {
    this.graph.drawErrorMessage(`
      申し訳ありません、通信エラーが発生しました。
      少し時間をおいて再度お試しください。
      ステータス: ${res.status}, ${new Date()}
    `);
  }

  seriesCount(): number {
    return this.graph.seriesCount();
  }

  getSeries(index: number): any {
    return this.graph.getSeries(index);
  }

  removeSeries(series: any): void {
    this.graph.removeSeries(series);
  }

  clear(): void {
    this.graph.clear();
  }

  hasNoData(): boolean {
    return this.graph.hasNoData();
  }

  addSeries(series: any): void {
    this.graph.addSeries(series);
  }
}

export { EasyResearchesForm };
